module.exports = __webpack_public_path__ + "static/media/icon-admin.e2e5a6be.svg";